angular.module('pitch.search')
.controller('PitchSearchCtrl',
    function($scope, $controller, searchLoader, UserTerritory, SearchConfig, $location, AdvancedFiltersModal, hotkeys, $rootScope, $state) {
        angular.extend(this, $controller('SearchCtrl', {
            $scope: $scope,
            searchLoader: searchLoader
        }));

        UserTerritory.get(function(r) {
            $scope.userTerritory = r;
        });

        $scope.sortByTerritoryControl = function() {
            $scope.sortBy('territoryControl_' + $scope.userTerritory.id);
        };

        $scope.isSortedByTerritoryControl = function() {
            return $scope.userTerritory &&
                SearchConfig.isset('sortBy') &&
                SearchConfig.getProperty('sortBy').indexOf('territoryControl_' + $scope.userTerritory.id) === 0;
        };

        $scope.reset = function() {
            SearchConfig.init({});
            $location.url($location.path());
        };

        $scope.showAdvancedFilters = function() {
            AdvancedFiltersModal.open();
        };

        $scope.modalIsOpen = false;

        var openTabModal = function(tab) {
            if(!$scope.modalIsOpen) {
                AdvancedFiltersModal.open({onClose: function() {
                        $scope.modalIsOpen = false;
                    }}).then(function () {
                    $rootScope.$broadcast('REQUEST_TAB_CHANGE', tab);
                });
                $scope.modalIsOpen = true;
            } else {
                $rootScope.$broadcast('REQUEST_TAB_CHANGE', tab);
            }
        };

        hotkeys.bindTo($scope)
            .add({
                combo: 'c',
                description: 'Open Chart Position Tab',
                callback: function() {
                    openTabModal(0);
                }
            })
            .add({
                combo: 'i',
                description: 'Open ID Search Tab',
                callback: function() {
                    openTabModal(1);
                }
            })
            .add({
                combo: 'm',
                callback: function(e, hotkey) {
                    e.preventDefault();
                    $state.go('myMusic.playlists');
                }
            })
        ;

    }
);



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/controllers/PitchSearchCtrl.js